import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import ApEditorMode from '../../../enums/ApEditorMode';
import { ApEditorActions, ApLocation } from '../../../sic-lib/reducers/actionPlanEditorReducer';
import { ApActionBase } from '../../../sic-lib/types/ActionPlan';
import ApEditorAction from '../ApEditorAction/ApEditorAction';
import ApEditorTimelineIcon from '../ApEditorTimelineIcon/ApEditorTimelineIcon';
import ApEditorTimelineNavigation from '../ApEditorTimelineNavigation/ApEditorTimelineNavigation';
import ApEditorTimelineToolbar from '../ApEditorTimelineToolbar/ApEditorTimelineToolbar';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
    },
    toolbar: {
        flexBasis: '56px',
        flexGrow: 0,
        padding: theme.spacing(1.5, 1, 1, 1),
    },
    navWrapper: {
        flexBasis: '56px',
        flexGrow: 0,
        padding: theme.spacing(1),
    },
    timelineWrapper: {
        flexBasis: 0,
        flexGrow: 1,
        height: 'calc(100% - 102px)',
        overflowY: 'scroll',
    },
    timeline: {
        height: 'auto',
        marginTop: 0,
        padding: theme.spacing(0, 0, 0, 1),
        '& .MuiTimelineItem-missingOppositeContent::before': {
            flex: 0,
            padding: 0,
        },
        '& .MuiTimelineContent-root': {
            paddingRight: theme.spacing(1),
        },
    },
}));

interface Props {
    contactId: number | undefined;
    apRootId: number;
    actions: ApActionBase[];
    apEditMode: ApEditorMode;
    apLocation: ApLocation[];
    apDispatch: React.Dispatch<ApEditorActions>;
}

export default function ApEditorTimeline({
    contactId,
    apRootId,
    actions,
    apEditMode,
    apLocation,
    apDispatch,
}: Props) {
    const { classes } = useStyles();

    return (
        <React.Fragment>
            <Grid container direction="column" wrap="nowrap" className={classes.root}>
                <Grid className={classes.navWrapper}>
                    <ApEditorTimelineNavigation apLocation={apLocation} apDispatch={apDispatch} />
                </Grid>
                <Grid item className={classes.toolbar}>
                    <ApEditorTimelineToolbar
                        apEditMode={apEditMode}
                        apLocation={apLocation}
                        apDispatch={apDispatch}
                        contactId={contactId}
                    />
                </Grid>
                <Grid item className={classes.timelineWrapper}>
                    <Timeline className={classes.timeline}>
                        {actions.map((act, idx, arr) => (
                            <TimelineItem key={act.actionId}>
                                <TimelineSeparator>
                                    <ApEditorTimelineIcon actionType={act.type} />
                                    {idx < arr.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent>
                                    <ApEditorAction
                                        action={act}
                                        actionIndex={idx}
                                        hasNextAction={idx < arr.length - 1}
                                        hasPrevAction={idx > 0}
                                        apRootId={apRootId}
                                        apEditMode={apEditMode}
                                        apDispatch={apDispatch}
                                    />
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
